module.exports = __webpack_public_path__ + "static/img/213_TO8_2157.6981f69.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/213_TO8_2157.jpg
// module id = IZyr
// module chunks = 0